/* ================= Lightweight Banner runtime state ================= */
/* The interactive game code is loaded later. Keep only the small state shared
   by the Banner's renderer and input layer in the first-screen path. */
var wheelAngle=0, dragAccum=0, wheelGlow=0;
var lastFrameT=performance.now();

function onWheelDelta(d){
  wheelAngle+=d;
  if(
    renderer &&
    renderer.domElement &&
    renderer.domElement.closest('[data-repod-experience]') &&
    typeof APP !== 'undefined' &&
    APP &&
    typeof APP.onWheel === 'function'
  ){
    APP.onWheel(d);
  }
}
